
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import { AlButton } from '~/components/ui'

@Component({
  components: { AlButton },
})
export default class BlackFridayProvider extends Vue {
  @Prop({ type: String, required: true })
  readonly text!: string

  @Prop({ type: String, required: true })
  readonly imgSrc!: string

  @Prop({ type: String, default: '' })
  readonly imgAlt!: string

  @Prop({ type: String, required: true })
  readonly linkText!: string

  @Prop({ type: String, required: true })
  readonly url!: string
}
